import { createSelector as createReselectSelector } from 'reselect';
import { createSelector as createReduxOrmSelector } from 'redux-orm';

import orm from '../orm';
import { selectCurrentUserId, selectAvailableResourcesForCurrentUser } from './users';
import matchPaths from '../utils/match-paths';
import Paths from '../constants/Paths';

export const selectPathname = ({
  router: {
    location: { pathname },
  },
}) => pathname;

export const selectPathsMatch = createReselectSelector(selectPathname, (pathname) =>
  matchPaths(pathname, Object.values(Paths)),
);

export const selectPath = createReduxOrmSelector(
  orm,
  selectPathsMatch,
  selectAvailableResourcesForCurrentUser,
  (state) => selectCurrentUserId(state),
  (
    { Project, Board, Card, User },
    pathsMatch,
    { projectIds, boardIds, cardIds },
    currentUserId,
  ) => {
    if (pathsMatch) {
      switch (pathsMatch.pattern.path) {
        case Paths.PROJECTS: {
          const projectModel = Project.withId(pathsMatch.params.id);
          console.log('route project id', pathsMatch.params.id);
          console.log('projectModel', projectModel);
          if (!projectModel) {
            return { projectId: null };
          }

          const userModel = User.withId(currentUserId);
          const isOrgMember =
            userModel?.organizationId && projectModel.organizationId === userModel.organizationId;

          // const { projectIds } = selectAvailableResourcesForCurrentUser(state);
          // const test = projectIds.has(projectModel.id);
          console.log('Projects dispo pour cet utilisateur', projectIds);
          // console.log('Est ce que projet est dispo pour l utilisateur', test);
          console.log(projectIds.has(projectModel.id));

          if (!isOrgMember && !projectIds.has(projectModel.id)) {
            return { projectId: null };
          }

          return {
            projectId: projectModel.id,
          };
        }
        case Paths.BOARDS: {
          const boardModel = Board.withId(pathsMatch.params.id);

          if (!boardModel || !boardIds.has(boardModel.id)) {
            return {
              boardId: null,
              projectId: null,
            };
          }

          return {
            boardId: boardModel.id,
            projectId: boardModel.projectId,
          };
        }
        case Paths.CARDS: {
          console.log('est ce qu on rentre dedans');
          const cardModel = Card.withId(pathsMatch.params.id);

          // console.log('Projects dispo pour cet utilisateur', cardIds);
          // console.log('Est ce que projet est dispo pour l utilisateur', test);
          console.log(cardIds);

          if (!cardModel || !cardIds.has(cardModel.id)) {
            return {
              cardId: null,
              boardId: null,
              projectId: null,
            };
          }

          return {
            cardId: cardModel.id,
            boardId: cardModel.boardId,
            projectId: cardModel.board.projectId,
          };
        }
        default:
      }
    }

    return {};
  },
);

export default {
  selectPathname,
  selectPathsMatch,
  selectPath,
};
